import React from 'react';
import {Box, Link, Typography, Stack, useTheme} from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import {useTranslation} from "react-i18next";

const Footer: React.FC = () => {
    const theme = useTheme();
    const {t} = useTranslation();
    return (
        <Box component="footer"
             width="100%"
             sx={{backgroundColor: theme.palette.primary.main}}>
            <Stack
                direction={{xs: 'column', sm: 'row'}}
                spacing={2}
                pt={2}
                justifyContent="center"
                alignItems="center"
                flexWrap="wrap"
            >
                <Link
                    href="/privacy-policy"
                    underline="hover"
                    sx={{display: 'flex', alignItems: 'center', gap: 0.5, color: 'white'}}
                >
                    <Typography color="white">
                        {t("PRIVACY_POLICY")}
                    </Typography>
                </Link>
                <Link
                    href="/gtc"
                    underline="hover"
                    sx={{display: 'flex', alignItems: 'center', gap: 0.5, color: 'white'}}
                >
                    <Typography color="white">
                        {t("GTC")}
                    </Typography>
                </Link>
                <Link
                    href="/imprint"
                    underline="hover"
                    sx={{display: 'flex', alignItems: 'center', gap: 0.5, color: 'white'}}
                >
                    <Typography color="white">
                        {t("IMPRINT")}
                    </Typography>
                </Link>
                <Link
                    href="/revocation"
                    underline="hover"
                    sx={{display: 'flex', alignItems: 'center', gap: 0.5, color: 'white'}}
                >
                    <Typography color="white">
                        {t("REVOCATION")}
                    </Typography>
                </Link>
                <Link
                    href="/shippingConditions"
                    underline="hover"
                    sx={{display: 'flex', alignItems: 'center', gap: 0.5, color: 'white'}}
                >
                    <Typography color="white">
                        {t("SHIPPING_CONDITIONS")}
                    </Typography>
                </Link>
                <Link
                    href="https://www.instagram.com/ninakscreationss?igsh=cmt0bXd0bmhycmJ0 "
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{display: 'flex', alignItems: 'center', gap: 0.5, color: 'white'}}
                >
                    <InstagramIcon
                        fontSize="small"
                        color="inherit"
                    />
                    <Typography color="white">
                        Instagram
                    </Typography>
                </Link>
            </Stack>

            <Typography variant="body2" color="white" align="center" mt={2} pb={2}>
                © {new Date().getFullYear()} {t("RIGHTS_RESERVED")}
            </Typography>
        </Box>
    );
};

export default Footer;
